import { CABECALHO_CSRF, sessaoAtual } from './auth';
import { buscar } from './buscar';

/**
 * AVISOS DE UMA VEZ SÓ (dono, 28/09): o que a PESSOA já leu fica no servidor — lido num aparelho,
 * não volta em outro. O navegador guarda uma cópia só para não perguntar toda vez.
 */
export type AvisoDeUmaVez = 'aviso-critico-v1' | 'tour-boas-vindas-v1';

/** Os avisos que a pessoa já leu; null = não deu para perguntar (sem rede, sem sessão). */
export async function lerAvisosLidos(): Promise<readonly string[] | null> {
  try {
    const r = await buscar('/api/me/avisos-lidos', {
      credentials: 'same-origin',
      headers: { accept: 'application/json' },
    });
    if (!r.ok) return null;
    return ((await r.json()) as { lidos: string[] }).lidos;
  } catch {
    return null;
  }
}

/** Marca no servidor (idempotente). Falhar não trava ninguém: na próxima abertura tenta de novo. */
export async function marcarAvisoLido(aviso: AvisoDeUmaVez): Promise<void> {
  try {
    const s = await sessaoAtual();
    if (!s) return;
    await fetch('/api/me/avisos-lidos', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'content-type': 'application/json', [CABECALHO_CSRF]: s.csrfToken },
      body: JSON.stringify({ aviso }),
    });
  } catch {
    // segue: a cópia do navegador segura até a próxima vez
  }
}
